export default __webpack_public_path__ + "static_media_list.3b408099.png";